import classNames from 'classnames'
import React, { FC } from 'react'

export interface RadioButtonProps {
	checked: boolean
	disabled?: boolean
	variant?: RadioButtonVariant
	label: string
	testId: string
	className?: string
	name: string
	value: string
	bold?: boolean
	onChange: (checked: boolean) => void
}

type RadioButtonVariant = 'light' | 'dark' | 'main' | 'main-dark'

const RadioButton: FC<RadioButtonProps> = ({
	checked,
	disabled = false,
	variant = 'light',
	label,
	testId,
	className,
	onChange,
	name,
	value,
	bold = true,
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		onChange(event.target.checked)
	}

	return (
		<label
			className={classNames('radio-button-container', variant, className)}
			data-testid={testId}
		>
			<div className="radio-button-wrapper">
				<input
					type="radio"
					checked={checked}
					onChange={handleChange}
					disabled={disabled}
					className={'radio-button-input'}
					name={name}
					value={value}
				/>
				<span className={'radio-button-custom'}></span>
			</div>
			<span
				className={classNames('ms-2 max-lg:text-sm', {
					'text-dark-grey': variant === 'dark',
					'font-semibold': bold,
				})}
			>
				{label}
			</span>
		</label>
	)
}

export default RadioButton
